var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-six"},[_c('div',{staticClass:"title"},[_vm._v("众多合作伙伴的一致认可")]),_c('div',{staticClass:"sub-title"},[_vm._v("感谢每一位合作伙伴的信任")]),_c('div',{staticClass:"card-wrap"},_vm._l((_vm.dataList),function(item){return _c('img',{key:item.id,staticClass:"card",class:item.class,attrs:{"src":item.icon,"alt":""}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }